<template>
  <div class="send-email-form">
    <HMModalHeader :title="title" @close="$emit('close')" />
    <ValidationObserver ref="form" v-slot="{ invalid }">
      <form @submit.prevent="submit">
        <HMTextInput
          type="text"
          rules="required"
          :label="$t('GENERAL.LABEL.EMAIL_SUBJECT')"
          v-model="subject"
          name="Email subject"
        />
        <div class="form-group">
          <label for="exampleFormControlTextarea1">{{
            $t('GENERAL.LABEL.EMAIL_MESSAGE')
          }}</label>
          <textarea v-model="body" class="form-control" rows="10"></textarea>
        </div>
        <HMModalFooter
          class="mt-3"
          :submitButton="$t('GENERAL.BUTTON.SEND')"
          :disabled="invalid"
          :formError="formError"
          @close="$emit('close')"
        />
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver } from 'vee-validate';

export default {
  name: 'HMSendEmailModal',
  components: {
    ValidationObserver,
  },
  props: {
    title: {
      type: String,
      default: 'GENERAL.TITLE.SEND_EMAIL',
    },
    sendEmail: { type: Function },
  },
  data() {
    return {
      subject: '',
      body: '',
      formError: null,
    };
  },
  computed: {},
  methods: {
    async submit() {
      await this.sendEmail(this.subject, this.body);
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
